import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { DrillCopySource } from 'app/model/pipeline/copysource/drill.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DrillCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class DrillCopySourceAdapter extends CopySourceAdapter<DrillCopySource, Model.DrillSource> {

    protected override async _toResource(copySource: DrillCopySource): Promise<Model.DrillSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(DrillCopySource).name);
    }

    protected override async _toModel(resource: Model.DrillSource, copyActivity: CopyActivity): Promise<DrillCopySource> {
        return this._toTabularModel(resource, copyActivity, DrillCopySource.MODEL);
    }
}
